import { j as e, a as r, F as a } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import f from "../../string-table.js";
import { Colors as t } from "../../1-foundations/Colors/Colors.js";
import { I as p } from "../../../Icon-CAQ-6E_J.js";
import { Asterisk as c } from "../../2-atoms/Asterisk/Asterisk.js";
import "../../../FeatureFlagProvider-DyczYY1y.js";
import "react";
import "@ionic/react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function E(m) {
  const {
    id: i,
    label: h,
    value: o,
    stacked: b,
    placeholder: u,
    onClick: n,
    isDisabled: l = !1,
    isRequired: s = !1
  } = m, d = () => /* @__PURE__ */ e("span", {
    id: `${i}-dropdown`,
    style: {
      fontWeight: "var(--swing-font-semibold"
    },
    children: h
  });
  return /* @__PURE__ */ e("div", {
    id: i,
    onClick: n,
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      padding: "16px 0",
      borderBottom: `1px solid ${t.slate200}`,
      cursor: "pointer"
    },
    children: b && o ? /* @__PURE__ */ r(a, {
      children: [/* @__PURE__ */ r("div", {
        children: [/* @__PURE__ */ r("div", {
          children: [/* @__PURE__ */ e(d, {}), s && /* @__PURE__ */ e(c, {})]
        }), /* @__PURE__ */ e("div", {
          children: o
        })]
      }), /* @__PURE__ */ e("button", {
        type: "button",
        disabled: l,
        style: {
          backgroundColor: "transparent"
        },
        children: /* @__PURE__ */ e(p, {
          name: "Chevron Down",
          color: t.blue500
        })
      })]
    }) : /* @__PURE__ */ r(a, {
      children: [/* @__PURE__ */ r("div", {
        children: [/* @__PURE__ */ e(d, {}), s && /* @__PURE__ */ e(c, {})]
      }), /* @__PURE__ */ r("div", {
        style: {
          display: "flex",
          gap: "4px",
          alignItems: "center"
        },
        children: [/* @__PURE__ */ e("span", {
          children: o || u || f("LABEL_SELECT")
        }), /* @__PURE__ */ e("button", {
          type: "button",
          disabled: l,
          onClick: n,
          style: {
            backgroundColor: "transparent"
          },
          children: /* @__PURE__ */ e(p, {
            name: "Chevron Down",
            color: t.blue500
          })
        })]
      })]
    })
  });
}
export {
  E as DropDown
};
